import React, {useEffect, useState} from "react";
import {Col} from "antd";
import _ from "lodash";

import stores from "../../../../store/stores";
import {
    CompanyFilter,
    SubCompanyFilter,
    ObjectionStatusFilter,
    LastRespondedByFilter,
    CityFilter
} from "../../../_defaultComponents/FilterComponents";

export type ObjectionsFiltersPropTypes = {
    setCurrentPage: () => {},
    setFilters: () => {},
    filters: Object
};
const ObjectionsFilters = ({setCurrentPage, filters, setFilters}: ObjectionsFiltersPropTypes) => {
    const [companyId, setCompanyId] = useState(filters.companyId);
    const [subCompanyId, setSubCompanyId] = useState(filters.subCompanyId);
    const [lastRespondedBy, setLastRespondedBy] = useState(filters.lastRespondedBy);
    const [status, setStatus] = useState(filters.status);
    const [city, setCity] = useState(filters.city);

    useEffect(() => {
        setCurrentPage(1);
    }, [companyId, subCompanyId, , lastRespondedBy, status, city]);

    useEffect(() => {
        const newFilters = {companyId, subCompanyId, lastRespondedBy, status, city};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            console.log({newFilters});
            setFilters(newFilters);
        }
    }, [companyId, subCompanyId, lastRespondedBy, status, city]);

    const onChangeCompany = value => {
        setCompanyId(value);
        setSubCompanyId("all");
    };

    const onChangeSubCompany = value => {
        setSubCompanyId(value);
    };

    return (
        <React.Fragment>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <CityFilter value={city} onChange={setCity} />
            </Col>
            {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                    <CompanyFilter
                        value={companyId}
                        onChange={onChangeCompany}
                        allKey={"all"}
                        showAllOption={true}
                        showPoolOption={false}
                    />
                </Col>
            )}
            {!["all"].includes(companyId) && (
                <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                    <SubCompanyFilter
                        value={subCompanyId}
                        onChange={onChangeSubCompany}
                        company={companyId}
                        disabled={false}
                        initialCall={
                            stores.meStore.checkRole("isCompanyUser") ||
                            stores.meStore.orderPage?.filters.companies?.length > 0
                        }
                    />{" "}
                </Col>
            )}
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <ObjectionStatusFilter value={status} onChange={setStatus} />
            </Col>

            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <LastRespondedByFilter value={lastRespondedBy} onChange={setLastRespondedBy} />
            </Col>
        </React.Fragment>
    );
};

export default ObjectionsFilters;
